import Link from 'next/link';
import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.header`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const LeftSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 40px;
`;

export const RightSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 40px;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

export const Title = styled(Typography.Header).attrs({ $variant: '3' })`
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const MenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: transparent;
  cursor: pointer;
`;

export const MenuButtonIconOutline = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 1px solid ${({ theme }) => theme.palette.primary.labels};
  border-radius: 50%;
`;

export const MenuContent = styled.div`
  width: 100%;
`;

export const MenuGrid = styled.nav`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 10px 15px;
`;

export const MenuItem = styled(Link)<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 15px;
  border-radius: 20px;
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: ${({ theme }) => theme.palette.secondary.background};

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${({ theme }) => theme.palette.system.deepBlue};
    `}
`;

export const MenuItemTitle = styled(Typography.Body).attrs({ $variant: '4' })`
  color: currentColor;
`;

export const MenuDivider = styled.div`
  height: 1px;
  margin: 15px;
  background-color: ${({ theme }) => theme.palette.primary.border};
`;

export const MenuLogoutButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  gap: 10px;
  width: 100%;
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.palette.primary.labels};
`;
